var _rect, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F2F4F5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9724,
    cy: 21.0002,
    r: 2.07692,
    transform: "rotate(-90 12.9724 21.0002)",
    fill: "#406EE2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8953,
    cy: 21.0002,
    r: 2.07692,
    transform: "rotate(-90 19.8953 21.0002)",
    fill: "#406EE2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8186,
    cy: 21.0002,
    r: 2.07692,
    transform: "rotate(-90 26.8186 21.0002)",
    fill: "#406EE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopup);
export default __webpack_public_path__ + "static/media/popup.7a768f8b65f0cc1a77c9a37260248c5b.svg";
export { ForwardRef as ReactComponent };